module.exports = __webpack_public_path__ + "img/renata.a95c7850.png";